var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 2.46875C3.125 2.15809 2.87316 1.90625 2.5625 1.90625C2.25184 1.90625 2 2.15809 2 2.46875V13.3438C2 13.6544 2.25184 13.9062 2.5625 13.9062C2.87316 13.9062 3.125 13.6544 3.125 13.3438V10.0502L4.36807 9.78846C5.45344 9.55996 6.58436 9.71147 7.57131 10.2176C8.95419 10.9268 10.5593 11.0679 12.0447 10.6108L13.6029 10.1314C13.8389 10.0588 14 9.84069 14 9.59375V3.21875C14 3.04923 13.9236 2.88876 13.7919 2.78195C13.6603 2.67514 13.4875 2.63339 13.3216 2.66831L11.5368 3.04406C10.4863 3.26522 9.3939 3.17048 8.39719 2.77179L8.02063 2.62117C6.81769 2.13999 5.49924 2.02566 4.23143 2.29256L3.125 2.5255V2.46875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/icon-flag.9966b54231c5bf1dd9613ad14b1ccaa7.svg";
export { ForwardRef as ReactComponent };